import { render, staticRenderFns } from "./SkinDialogComponent.vue?vue&type=template&id=00854024&scoped=true"
import script from "./SkinDialogComponent.vue?vue&type=script&lang=js"
export * from "./SkinDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00854024",
  null
  
)

export default component.exports